<template>
  <div :key="index+'article_home'" class="baseFormBox">
    <div :key="index+'article_box'" v-html="options.value" class="article_html">
    </div>
    <slot></slot>
  </div>

</template>

<script> 
import { mapGetters } from "vuex";
export default {
  props: ["index"],
  data() {
    return {
      form: {},
      keyValue: 0
    };
  },
  computed: {
    ...mapGetters(["formwork"]),
    options() {
      return this.formwork[this.index] ? this.formwork[this.index].options : { options: this.formwork.articleOptions };
    },
  },
};
</script> 
<style scoped>
.article_html {
  /* 强制换行 */
  word-break: break-all;
}
</style>